import { trackEvent, getSessionId, getDeviceInfo } from './analytics';

/**
 * Fonction utilitaire à appeler sur chaque page pour tracker une visite
 * @param {string} [eventType='pageview']
 * @param {object} [eventData={}] - Données additionnelles éventuelles
 */
export default function trackPageView(eventType = 'pageview', eventData = {}) {
  const info = getDeviceInfo();
  const sessionId = getSessionId();
  const page_url = window.location.pathname + window.location.search;
  const referrer = document.referrer || null;
  
  // Récupérer l'ID utilisateur si connecté (depuis le localStorage ou autre)
  let user_id = null;
  try {
    // Vérifier si l'utilisateur est connecté (adapté à la structure de l'app)
    const authData = localStorage.getItem('authData');
    if (authData) {
      const parsedData = JSON.parse(authData);
      user_id = parsedData.user?.id || null;
    }
  } catch (e) {
    console.error('Erreur lors de la récupération de l\'ID utilisateur:', e);
  }

  // Envoyer les données de tracking selon la structure de la table site_visits
  trackEvent({
    session_id: sessionId,
    user_id,
    page_url,
    referrer,
    // Informations sur le navigateur et l'appareil
    ...info,
    // Type d'événement et données supplémentaires
    event_type: eventType,
    event_data: eventData,
    // Estimer la durée (sera mise à jour lors de la navigation ou fermeture)
    duration_seconds: 0,
    // Détection basique de bot (peut être améliorée)
    is_bot: /bot|crawler|spider|crawling/i.test(navigator.userAgent)
  });
}
